import { VariableSummary } from '@mtna/variable-service-core-ts';

/**
 *  Available column types
 * 'selected' - Used to determine if a row is selected, i.e. the checkbox column
 * 'editButton' - Column for edit button
 */
export type RDS_DATA_DICTIONARY_COLUMNS = keyof VariableSummary | 'selected' | 'hasClassification' | 'editButton';

/**
 * Describes a column in a RDS Data Dictionary Table
 */
export class RdsDataDictionaryTableColumn {
  /**
   * Creates an instance of RdsDataDictionaryTableColumn.
   * @param property variable property name
   * @param label display text for property
   * @param index order the column will appear in the table
   * @param required whether the property is required and can't be toggled, defaults to false
   */
  constructor(public property: RDS_DATA_DICTIONARY_COLUMNS, public label: string, public index: number, public required = false) {}
}

export const RDS_DATA_DICTIONARY_ALL_COLUMNS: ReadonlyArray<RdsDataDictionaryTableColumn> = Object.freeze([
  new RdsDataDictionaryTableColumn('selected', $localize`Selected`, 0, true),
  new RdsDataDictionaryTableColumn('editButton', $localize`Edit`, 1, true),
  new RdsDataDictionaryTableColumn('name', $localize`Name`, 2),
  new RdsDataDictionaryTableColumn('label', $localize`Label`, 3),
  new RdsDataDictionaryTableColumn('dataType', $localize`Data Type`, 4),
  new RdsDataDictionaryTableColumn('hasClassification', $localize`Has Classification`, 5),
  new RdsDataDictionaryTableColumn('description', $localize`Description`, 6),
  new RdsDataDictionaryTableColumn('questionText', $localize`Question Text`, 7),
  new RdsDataDictionaryTableColumn('isMeasure', $localize`Is Measure`, 8),
  new RdsDataDictionaryTableColumn('isRequired', $localize`Required`, 9),
  new RdsDataDictionaryTableColumn('isWeight', $localize`Is Weight`, 10),
]);
